import * as angular from 'angular';

class ShippersIndividualContacts implements ng.IController {
    private currentContact: ContactPersonDto = <ContactPersonDto>{};
    private dispatchingCountry: string;
    private department: string;
    private contactType: string;
    private dispatchingAddress: AddressDto;
    private type: any = {
        dispatching: 'DISPATCHING',
        dispatchingCentral: 'DISPATCHING_CENTRAL',
        billing: 'BILLING',
        communication: 'COMMUNICATION',
        operation: 'OPERATION'
    };

    constructor(
        private countryService: any,
        private COUNTRIES: any
    ) {}

    $onInit(): void {
        this.setDepartment(this.contactType);
        this.setCountry(this.dispatchingAddress);
    }

    public setDepartment(contactType) {
        switch (contactType) {
            case this.type.dispatching: {
                this.department = 'Dispatching';
                break;
            }
            case this.type.dispatchingCentral: {
                this.department = 'Dispatching (central)';
                break;
            }
            case this.type.billing: {
                this.department = 'Billing';
                break;
            }
            case this.type.communication: {
                this.department = 'Communication';
                break;
            }
            case this.type.operation: {
                this.department = 'Operations Department';
                break;
            }
            default: {
                this.department = '';
                break;
            }
        }
    }

    private setCountry(address: AddressDto) {
        if (address != null) {
            this.dispatchingCountry = this.countryCodeToCountryName(
                this.dispatchingAddress.countryCode
            );
        }
    }

    public countryCodeToCountryName(countryCode) {
        if (countryCode != null) {
            return this.countryService.getCountryByCode(
                this.COUNTRIES,
                countryCode
            );
        }
    }

    public collapse(
        idOfCurrentlyExpandedContact: number,
        contact: ContactPersonDto
    ): void {
        if (idOfCurrentlyExpandedContact) {
            this.currentContact = contact;
        }
    }
}

angular.module('app').component('pkpShippersIndividualContacts', {
    controller: ShippersIndividualContacts,
    template: require('app/_directives/shippers-individual-contacts.directive.html'),
    bindings: {
        contactCategory: '@',
        contactType: '@',
        individualContacts: '<',
        dispatchingAddress: '<',
        dispatchingCommunicationInfo: '<'
    }
});
